import Layout from '@/layout/Index.vue'

// 与菜单 URL 保持一致，子页面通过 activeMenu 继承菜单和按钮权限。
export default [{
  path: '/specialWork',
  component: Layout,
  redirect: '/specialWork/list',
  meta: { title: '电子特殊作业票' },
  children: [
    { path: 'list', meta: { title: '电子特殊作业票', activeMenu: '/specialWork' }, component: () => import('@/views/specialWork/List.vue') },
    { path: 'add', meta: { title: '新增特殊作业申请', activeMenu: '/specialWork' }, component: () => import('@/views/specialWork/Add.vue') },
    { path: 'detail', meta: { title: '特殊作业票详情', activeMenu: '/specialWork' }, component: () => import('@/views/specialWork/Detail.vue') }
  ]
}]
